
export const URL = "https://api.cloudpayments-staging.com/";
export const headers = {
  "Content-Type": "application/json",
  "API-KEY": "613a606b20808900019edcd6e0d540ed0f9243e89a7393fd0b46ae92",
  tenantName: "IBANERA",
  DEVICE_OS: "",
  DEVICE_ID: "",
  TIMEZONE: "",
  IP_ADDRESS: "",
};

export const login = async (username, password) => {

    var details = {
        'username': username,
        'password': password,
        'grant_type': 'password'
    };

    var formBody = [];
    for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");

    const response = await fetch(URL + "auth/oauth/token", {
        method: "POST",
        headers: Object.assign({}, headers, {
          "Content-Type": "application/x-www-form-urlencoded",
        }),
        body: formBody,
    }).then(response => response.json());

    return response
}